import R from 'app/assets/R'
import { StatusEnum } from './type'
import { convertedVariables } from 'app/styles/themes/themeVariables'

export const DefineStatusEnum = {
  [StatusEnum.Duplicated]: {
    text: R.strings.duplicated_treatment,
    color: convertedVariables.statesRedColor,
  },
  [StatusEnum.NotFoundTreatment]: {
    text: R.strings.not_found_treatment,
    color: convertedVariables.statesRedColor,
  },
  [StatusEnum.WrongMaximumDiscount]: {
    text: R.strings.wrong_maximum_discount,
    color: convertedVariables.statesRedColor,
  },

  [StatusEnum.Success]: {
    text: R.strings.success,
    color: convertedVariables.statesGreenColor,
  },
}
